/* Saga Personalisation Product Layout (preview 2026-09-15). Loaded only on product pages that
   snippets/saga-pers-gate.liquid lets in (sections/main-product.liquid adds .saga-pers).

   WHAT IT DOES
   1. Colour row: finds the product's group in the swatch app's data (window.starapps_data, the existing sibling
      relation), asks templates/search.saga-pers.liquid for each sibling's Shopify data in the visitor's language
      (localised URL, product photo, colour name from the title) and renders small swatches. Plain colours use the
      swatch app's hex; a design without a hex is shown with a crop of its real product photo. Desktop pointers get
      a small product window on hover/focus; touch devices get plain links (tap = go to that product).
   2. Name field: Globo's own input stays where Globo put it and keeps doing all the work (property, validation,
      0 kr add-on line). This only adds a translated label, help text, character counter and error text around it,
      and hides Globo's untranslated label, counter and message. Nothing is added until the Globo input exists.
   3. Mix & Save: the server-rendered card (only on products covered by the discount) is moved under the name
      field and the tier reached by the chosen quantity is highlighted.

   WHAT IT NEVER DOES: call the cart API, intercept Add to Cart, move a Globo node, or invent data. No text lives
   here; strings come from window.SagaPers.i18n (locales/*.json, saga.pers). */
(function () {
  'use strict';
  var C = window.SagaPers;
  var root = document.querySelector('.product-detail.saga-pers');
  if (!C || !root) return;

  var dec = document.createElement('textarea');
  function t(key, map) {
    dec.innerHTML = String((C.i18n || {})[key] || '');
    var s = dec.value, k;
    if (map) for (k in map) if (Object.prototype.hasOwnProperty.call(map, k)) s = s.split(k).join(map[k]);
    return s;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function after(ref, node) { ref.parentNode.insertBefore(node, ref.nextSibling); }
  function waitFor(test, ms, cb) {
    var start = Date.now();
    (function tick() {
      var v = null;
      try { v = test(); } catch (e) { v = null; }
      if (v) return cb(v);
      if (Date.now() - start > ms) return cb(null);
      setTimeout(tick, 120);
    })();
  }
  function sized(url, w) {
    if (!url) return url;
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var localeRoot = String(C.root || '/').replace(/\/?$/, '/');

  /* ---------------------------------------------------------------- 1. colour row */
  var box = root.querySelector('[data-saga-pers-colour]');
  if (box) {
    waitFor(function () { var d = window.starapps_data; return d && d.product_groups; }, 6000, function (groups) {
      var pid = Number(C.productId), group = null, i;
      if (groups) {
        for (i = 0; i < groups.length; i++) {
          if ((groups[i].option_values || []).some(function (v) { return Number(v.id) === pid; })) { group = groups[i]; break; }
        }
      }
      /* Extra design swatches (Theme settings): products that are not in the swatch app, attached to one group.
         On their own page they use that group; on the group's pages they are appended. Data comes from Shopify. */
      var extra = (C.extra || []).filter(function (x) { return x && x.id; });
      if (!group && C.extraGroup && groups && extra.some(function (x) { return Number(x.id) === pid; })) {
        for (i = 0; i < groups.length; i++) { if (String(groups[i].id) === String(C.extraGroup)) { group = groups[i]; break; } }
      }
      var members = group ? group.option_values.filter(function (v) { return v.published !== false && v.handle; }) : [];
      if (group && C.extraGroup && String(group.id) === String(C.extraGroup)) {
        extra.forEach(function (x) {
          if (!members.some(function (m) { return Number(m.id) === Number(x.id); })) {
            members.push({ id: x.id, handle: x.handle, swatch_src: 'file', swatch_value: null, published: true, sagaExtra: x });
          }
        });
      }
      if (members.length < 2) { box.parentNode.removeChild(box); return; }
      buildSwatches(members);
    });
  }

  function buildSwatches(members) {
    var list = box.querySelector('[data-saga-pers-list]');
    var byHandle = {};
    var items = members.map(function (v) {
      var li = el('li', 'saga-pers-sw-item');
      var a = el('a', 'saga-pers-sw');
      a.href = localeRoot + 'products/' + v.handle;
      var current = Number(v.id) === Number(C.productId);
      if (current) { a.classList.add('is-current'); a.setAttribute('aria-current', 'true'); }
      var dot = el('span', 'saga-pers-sw__dot');
      var hex = v.swatch_src === 'color' && /^#[0-9a-f]{3,8}$/i.test(String(v.swatch_value || '')) ? v.swatch_value : null;
      if (hex) dot.style.setProperty('--sw', hex); else a.classList.add('is-design');
      var sr = el('span', 'saga-pers-sr');
      a.appendChild(dot); a.appendChild(sr); li.appendChild(a); list.appendChild(li);
      var it = { v: v, a: a, li: li, dot: dot, sr: sr, current: current, hex: hex, data: null };
      if (v.sagaExtra) {
        it.data = v.sagaExtra;
        if (it.data.url) a.href = it.data.url;
        var xname = it.data.name || it.data.title;
        sr.textContent = xname;
        a.setAttribute('aria-label', t('view', { '%s': xname }));
        if (it.data.image) {
          var ximg = el('img');
          ximg.alt = ''; ximg.loading = 'lazy'; ximg.decoding = 'async';
          ximg.src = sized(it.data.image, 160);
          var focus = String(C.extraFocus || '50% 50%');
          ximg.style.objectPosition = focus;
          ximg.style.transformOrigin = focus;
          ximg.style.transform = 'scale(' + (Number(C.extraZoom || 20) / 10) + ')';
          dot.appendChild(ximg);
        }
      } else {
        byHandle[v.handle] = it;
      }
      return it;
    });
    box.classList.add('is-ready');
    balanceRows(list);

    var url = String(C.search || (localeRoot + 'search')) + '?view=saga-pers&type=product&q=' +
      encodeURIComponent(members.filter(function (v) { return !v.sagaExtra; }).map(function (v) { return v.handle; }).join(' '));
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (txt) {
        var json = JSON.parse(txt);
        (json.items || []).forEach(function (d) {
          var it = byHandle[d.handle];
          if (!it) return;
          it.data = d;
          if (d.url) it.a.href = d.url;
          var name = d.name || d.title;
          it.sr.textContent = name;
          it.a.setAttribute('aria-label', t('view', { '%s': name }));
          if (!it.hex && d.image) {
            var img = el('img');
            img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
            img.src = sized(d.image, 120);
            it.dot.appendChild(img);
          }
        });
        /* a swatch-app member Shopify did not return is not for sale: leave it out rather than link to it */
        items.forEach(function (it) { if (!it.data && !it.current && it.li.parentNode) it.li.parentNode.removeChild(it.li); });
        var live = items.filter(function (it) { return it.data && it.li.parentNode; });
        if (live.length < 2) { if (box.parentNode) box.parentNode.removeChild(box); return; }
        balanceRows(list);
        if (finePointer) hoverCard(live);
      })
      .catch(function () {
        /* no Shopify data: keep plain colour links and extra swatches (their data came with the page), no hover window */
        items.forEach(function (it) { if (!it.hex && !it.current && !it.v.sagaExtra && it.li.parentNode) it.li.parentNode.removeChild(it.li); });
        balanceRows(list);
      });
  }

  /* Never leave one swatch alone on a row: when the row has to wrap, narrow the list so the rows even out
     (9 swatches with room for 8 -> 5 + 4). Re-checked on resize/rotation. Layout only - no text, no links changed. */
  var balanceBound = false;
  function balanceRows(list) {
    function run() {
      list.style.maxWidth = '';
      var lis = [].slice.call(list.children);
      if (lis.length < 3) return;
      var top = lis[0].offsetTop, perRow = 0;
      while (perRow < lis.length && lis[perRow].offsetTop === top) perRow++;
      if (perRow >= lis.length || perRow < 2) return;
      var rows = Math.ceil(lis.length / perRow), cols = Math.ceil(lis.length / rows);
      if (cols >= perRow) return;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      list.style.maxWidth = Math.ceil(cols * lis[0].offsetWidth + (cols - 1) * gap + 1) + 'px';
    }
    run();
    if (!balanceBound) {
      balanceBound = true;
      var timer = null;
      window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    }
  }

  function hoverCard(items) {
    var card = el('div', 'saga-pers-card');
    card.setAttribute('aria-hidden', 'true');
    var frame = el('div', 'saga-pers-card__img');
    var img = el('img');
    img.alt = ''; img.decoding = 'async';
    frame.appendChild(img);
    var name = el('p', 'saga-pers-card__name');
    card.appendChild(frame); card.appendChild(name);
    box.appendChild(card);

    var preloaded = false, active = null, hideTimer = null;
    function preload() {
      if (preloaded) return;
      preloaded = true;
      items.forEach(function (it) { if (it.data.image) { var im = new Image(); im.decoding = 'async'; im.src = sized(it.data.image, 480); } });
    }
    function place(it) {
      var br = box.getBoundingClientRect(), ar = it.a.getBoundingClientRect();
      var w = card.offsetWidth, h = card.offsetHeight;
      var vw = document.documentElement.clientWidth;
      var cx = ar.left + ar.width / 2 - br.left;
      var left = Math.max(12 - br.left, Math.min(cx - w / 2, vw - 12 - br.left - w));
      var above = ar.top - h - 14 >= 8;
      var top = above ? (ar.top - br.top - h - 10) : (ar.bottom - br.top + 10);
      card.style.left = Math.round(left) + 'px';
      card.style.top = Math.round(top) + 'px';
      card.style.setProperty('--caret', Math.round(cx - left) + 'px');
      card.classList.toggle('is-below', !above);
    }
    function show(it) {
      clearTimeout(hideTimer);
      if (!it.data.image) return;
      if (active !== it) {
        active = it;
        img.src = sized(it.data.image, 480);
        name.textContent = it.data.name || it.data.title;
      }
      place(it);
      card.classList.add('is-visible');
    }
    function hide() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { card.classList.remove('is-visible'); active = null; }, 80);
    }
    box.addEventListener('pointerenter', preload);
    items.forEach(function (it) {
      it.a.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') show(it); });
      it.a.addEventListener('pointerleave', hide);
      it.a.addEventListener('focus', function () { preload(); show(it); });
      it.a.addEventListener('blur', hide);
    });
    window.addEventListener('scroll', function () { if (active) place(active); }, { passive: true });
    window.addEventListener('resize', function () { if (active) place(active); });
  }

  /* ---------------------------------------------------------------- 2 + 3. name field and Mix & Save */
  var qtyInput = root.querySelector('.quantity-submit-row input[name="quantity"]');
  var mix = root.querySelector('[data-saga-pers-mix]');
  function qty() { var n = parseInt(qtyInput && qtyInput.value, 10); return isNaN(n) || n < 1 ? 1 : n; }
  var refreshers = [];
  function refresh() { refreshers.forEach(function (f) { f(); }); }

  if (mix) {
    var tiers = [].slice.call(mix.querySelectorAll('[data-qty]'));
    refreshers.push(function () {
      var n = qty(), reached = null;
      tiers.forEach(function (li) { if (n >= Number(li.getAttribute('data-qty'))) reached = li; });
      tiers.forEach(function (li) { li.classList.toggle('is-active', li === reached); });
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('input', refresh);
    qtyInput.addEventListener('change', refresh);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-quantity]')) setTimeout(refresh, 0);
    });
  }
  refresh();

  var submit = root.querySelector('.quantity-submit-row__submit');
  if (!submit) return;
  waitFor(function () { return submit.querySelector('.gpo-container input[type="text"][name]'); }, 9000, function (input) {
    var gc = input && input.closest('.gpo-container');
    if (!input || !gc) return;

    var max = input.maxLength > 0 ? input.maxLength : 0;
    if (!input.id) input.id = 'saga-pers-name';
    /* Globo's placeholder is English on every language; the attribute is display only, never order data */
    if (t('namePlaceholder')) input.setAttribute('placeholder', t('namePlaceholder'));
    var label = el('label', 'saga-pers-name__label', t('nameLabel'));
    label.htmlFor = input.id;
    var meta = el('div', 'saga-pers-name__meta');
    var help = el('span', 'saga-pers-name__help', t('nameHelp'));
    help.id = 'saga-pers-name-help';
    meta.appendChild(help);
    var count = null;
    if (max) { count = el('span', 'saga-pers-name__count'); meta.appendChild(count); }
    var err = el('p', 'saga-pers-name__error', t('nameError'));
    err.id = 'saga-pers-name-error'; err.setAttribute('role', 'alert'); err.hidden = true;
    var summary = el('p', 'saga-pers-summary');
    summary.setAttribute('aria-live', 'polite'); summary.hidden = true;

    gc.parentNode.insertBefore(label, gc);
    after(gc, meta); after(meta, err); after(err, summary);
    if (mix) after(summary, mix);
    input.setAttribute('aria-describedby', 'saga-pers-name-help saga-pers-name-error');
    root.classList.add('saga-pers-ready');

    refreshers.push(function () {
      var v = String(input.value || '');
      if (count) count.textContent = v.length + '/' + max;
      var n = qty(), nm = v.trim();
      if (n > 1 && nm) { summary.textContent = t('summary', { '%q': String(n), '%s': nm }); summary.hidden = false; }
      else summary.hidden = true;
    });
    input.addEventListener('input', function () { err.hidden = true; root.classList.remove('saga-pers-invalid'); refresh(); });

    /* Globo shows "This field is required" (English on every language) inside .messages when Add to Cart is
       pressed without a name; mirror that state with the translated message. */
    function syncError() {
      var m = gc.querySelector('.messages');
      var has = !!(m && m.textContent.replace(/\s+/g, '').length);
      err.hidden = !has;
      root.classList.toggle('saga-pers-invalid', has);
    }
    new MutationObserver(syncError).observe(gc, { childList: true, subtree: true, characterData: true });
    refresh();
  });
})();
